import { createGlobalStyle } from "styled-components";
import { device } from "./config/sizes";

import { appColors } from "./config/colors";

import InterRegularWoff from "./assets/fonts/inter-v3-latin-regular.woff";
import InterRegularWoff2 from "./assets/fonts/inter-v3-latin-regular.woff2";
import InterBoldWoff from "./assets/fonts/inter-v3-latin-700.woff";
import InterBoldWoff2 from "./assets/fonts/inter-v3-latin-700.woff2";
import SpaceMonoRegularWoff from "./assets/fonts/space-mono-v6-latin-regular.woff";
import SpaceMonoRegularWoff2 from "./assets/fonts/space-mono-v6-latin-regular.woff2";
import SpaceMonoBoldWoff from "./assets/fonts/space-mono-v6-latin-700.woff";
import SpaceMonoBoldWoff2 from "./assets/fonts/space-mono-v6-latin-700.woff2";

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    src: local(""),
      url(${InterRegularWoff2}) format("woff2"), 
      url(${InterRegularWoff}) format("woff"); 
  }

  @font-face {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    src: local(""),
      url(${InterBoldWoff2}) format("woff2"), 
      url(${InterBoldWoff}) format("woff"); 
  }

  @font-face {
    font-family: "Space Mono";
    font-style: normal;
    font-weight: 400;
    src: local(""),
      url(${SpaceMonoRegularWoff2}) format("woff2"), 
      url(${SpaceMonoRegularWoff}) format("woff"); 
  }

  @font-face {
    font-family: "Space Mono";
    font-style: normal;
    font-weight: 700;
    src: local(""),
      url(${SpaceMonoBoldWoff2}) format("woff2"), 
      url(${SpaceMonoBoldWoff}) format("woff"); 
  }

  html {
    box-sizing: border-box;
    background-color: ${appColors.backgroundPrimary};
    font-size: 16px;

    @media ${device.future} { 
      font-size: 17px;
    }

    @media ${device.desktop} { 
      font-size: 16px;
    }

    @media ${device.tablet} { 
      font-size: 15px;
    }

    @media ${device.mobile} { 
      font-size: 14px;
    }
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  html,
  body {
    margin: 0;
    padding: 0;
  }

  body {
    font-family: "Inter", Helvetica, sans-serif;
    font-size: 1.2rem;
    line-height: 1.6;
    color: ${appColors.fontPrimary};
    overflow: hidden;
  }

  h1, h2, h3 {
    font-family: "Space Mono", Courier, monospace;
  }

  h1, h2 {
    margin-top: 0;
    font-size: 1.5em;
  }

  p {
    margin: 1rem 0 2rem;
  }

  ul {
    padding-left: 1em;
  }

  li {
    padding: 0.25em 0.5em;
  }
`;
